import { useEffect } from "react";

/**
 * ─────────────────────────────────────────────────────────────────────────────
 *  BOOT SPLASH GATE
 * ─────────────────────────────────────────────────────────────────────────────
 *  Retire en fondu l'écran de démarrage statique rendu dans `index.html`
 *  (`#boot-splash`) dès que l'application React a peint son premier cadre.
 *
 *  Timing :
 *   - attend le premier rendu (le gate est monté dans Providers)
 *   - laisse l'animation du logo (cycle 6,4 s) se déployer pendant au moins
 *     ~2,2 s pour un accueil premium, sans bloquer l'utilisateur plus longtemps
 *   - ajoute la classe `.boot-splash--leave` (fondu 700 ms) puis retire le noeud
 *
 *  Idempotent : si l'élément est déjà absent (HMR, re-montage), no-op.
 * ─────────────────────────────────────────────────────────────────────────────
 */

const SPLASH_ELEMENT_ID = "boot-splash";
const SPLASH_MIN_VISIBLE_MS = 2_200;
const SPLASH_FADE_MS = 800;

export const BootSplashGate = () => {
  useEffect(() => {
    const splash = document.getElementById(SPLASH_ELEMENT_ID);
    if (!splash) return;

    let fadeTimer: number | undefined;
    let removeTimer: number | undefined;

    fadeTimer = window.setTimeout(() => {
      splash.classList.add("boot-splash--leave");
      removeTimer = window.setTimeout(() => splash.remove(), SPLASH_FADE_MS);
    }, SPLASH_MIN_VISIBLE_MS);

    return () => {
      window.clearTimeout(fadeTimer);
      window.clearTimeout(removeTimer);
    };
  }, []);

  return null;
};
